import { SidebarContainer } from "./Sidebar.elements";

import { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import { accountTypes } from "../../utils/accountTypes.utils";
import { AuthContext } from "../../context/authentication/Auth.context";
import { VpsAlertContext } from "../../context/vpsAlert/vpsAlert.context";
import { LayoutContext } from "../../context/layouts/Layout.context";
import Backdrop from "../ui/backdrop/Backdrop";
import { RequestAccountsContext } from "../../context/requests/RequestAccounts.context";
import { MemberState } from "../../context/members/Member.context";
import { RequestPagesContext } from "../../context/requestPage/RequestPages.context";

const Sidebar = () => {
  const { showSidebar, onShowSidebar } = useContext(LayoutContext);
  const { currentUser, logout } = useContext(AuthContext);
  const { vpsState } = useContext(VpsAlertContext);
  const { memberState } = MemberState();
  const { requestAlert, findAllRequest } = useContext(RequestAccountsContext);
  const { requestPageAlert, findAllRequestPage } =
    useContext(RequestPagesContext);

  const [dropdownManage, setDropdownManage] = useState(false);
  const [dropdownStock, setDropdownStock] = useState(false);

  let pathname = useLocation().pathname;

  useEffect(() => {
    findAllRequest("");
    findAllRequestPage("");
  }, [findAllRequest, findAllRequestPage]);

  if (!currentUser._id) {
    return (
      <SidebarContainer>
        <div className="loader">Loading...</div>
      </SidebarContainer>
    );
  }

  let alertCount = vpsState.vpsAlerts.filter(
    (vps) => new Date(vps.expDate).getTime() <= new Date().getTime()
  ).length;
  let memberCount = memberState.members.filter(
    (member) => new Date(member.expDate).getTime() <= new Date().getTime()
  ).length;

  if (+currentUser.role <= 3) {
    alertCount = vpsState.vpsAlerts.filter(
      (vps) =>
        vps.createdBy === currentUser._id &&
        new Date(vps.expDate).getTime() <= new Date().getTime()
    ).length;

    memberCount = memberState.members.filter(
      (member) =>
        member.createdBy === currentUser._id &&
        new Date(member.expDate).getTime() <= new Date().getTime()
    ).length;
  }

  return (
    <>
      <Backdrop show={showSidebar} closeBackdrop={() => onShowSidebar(false)} />
      <SidebarContainer>
        <aside className={showSidebar ? "show" : ""}>
          <button id="close-btn" onClick={() => onShowSidebar(false)}>
            <span className="material-icons-sharp"> close </span>
          </button>
          <div className="sidebar">
            {(+currentUser.role === 2 || +currentUser.role > 3) && (
              <div className="sidebar-menu">
                <h3 className="text-muted">Dashboard</h3>
                <Link
                  to="/admin/dashboard-accounts"
                  className={`${
                    pathname === "/admin/dashboard-accounts" ? "active" : ""
                  }`}
                  onClick={() => onShowSidebar(false)}
                >
                  <span className="material-icons-sharp"> people </span>
                  <h4>Accounts</h4>
                </Link>
                <Link
                  to="/admin/dashboard-pages"
                  className={`${
                    pathname === "/admin/dashboard-pages" ? "active" : ""
                  }`}
                  onClick={() => onShowSidebar(false)}
                >
                  <span className="material-icons-sharp"> web </span>
                  <h4>Pages</h4>
                </Link>
                <Link
                  to="/admin/dashboard-vps"
                  className={`${
                    pathname === "/admin/dashboard-vps" ? "active" : ""
                  }`}
                  onClick={() => onShowSidebar(false)}
                >
                  <span className="material-icons-sharp"> dns </span>
                  <h4>Vps</h4>
                </Link>

                <Link
                  to="/admin/dashboard-members"
                  className={`${
                    pathname === "/admin/dashboard-members" ? "active" : ""
                  }`}
                  onClick={() => onShowSidebar(false)}
                >
                  <span className="material-icons-sharp">
                    supervised_user_circle
                  </span>
                  <h4>Members</h4>
                </Link>
                <Link
                  to="/admin/sales-analytics"
                  className={`${
                    pathname === "/admin/sales-analytics" ? "active" : ""
                  }`}
                  onClick={() => onShowSidebar(false)}
                >
                  <span className="material-icons-sharp">
                    signal_cellular_alt
                  </span>
                  <h4>Analytics</h4>
                </Link>
              </div>
            )}

            <>
              <div className="sidebar-menu">
                <h3 className="text-muted">Accounts</h3>
                <div
                  className="sidebar-dropdown"
                  onClick={() => setDropdownManage((prev) => !prev)}
                >
                  <span className="material-icons-sharp">work_outline</span>
                  <h4>Manage</h4>
                </div>

                <div
                  className={`dropdown-item ${dropdownManage ? `show` : ""}`}
                >
                  {accountTypes.map((accType) => (
                    <Link
                      key={accType.name}
                      className={`${
                        pathname === `/admin/manage-accounts/${accType.name}`
                          ? "active"
                          : ""
                      }`}
                      to={`/admin/manage-accounts/${accType.name}`}
                      onClick={() => onShowSidebar(false)}
                    >
                      <span className="material-icons-sharp">attach_money</span>
                      <h4>{accType.name}</h4>
                    </Link>
                  ))}
                </div>

                {(+currentUser.role === 10 || +currentUser.role === 3) && (
                  <>
                    <div
                      className="sidebar-dropdown"
                      onClick={() => setDropdownStock((prev) => !prev)}
                    >
                      <span className="material-icons-sharp">inventory_2</span>
                      <h4>Stock</h4>
                    </div>
                    <div
                      className={`dropdown-item ${dropdownStock ? `show` : ""}`}
                    >
                      {accountTypes.map((accType) => (
                        <Link
                          key={accType.name}
                          className={`${
                            pathname === "/admin/manage-stock/" + accType.name
                              ? "active"
                              : ""
                          }`}
                          to={`/admin/manage-stock/${accType.name}`}
                          onClick={() => onShowSidebar(false)}
                        >
                          <span className="material-icons-sharp">
                            attach_money
                          </span>
                          <h4>{accType.name}</h4>
                        </Link>
                      ))}
                    </div>

                    <Link
                      to="/admin/upload-accounts"
                      className={`${
                        pathname === "/admin/upload-accounts" ? "active" : ""
                      }`}
                      onClick={() => onShowSidebar(false)}
                    >
                      <span className="material-icons-sharp">upload</span>
                      <h4>Upload</h4>
                    </Link>
                    <Link
                      to="/admin/download-accounts"
                      className={`${
                        pathname === "/admin/download-accounts" ? "active" : ""
                      }`}
                      onClick={() => onShowSidebar(false)}
                    >
                      <span className="material-icons-sharp">download</span>
                      <h4>Download</h4>
                    </Link>
                  </>
                )}
              </div>

              <div className="sidebar-menu">
                <h3 className="text-muted">Request</h3>
                {+currentUser.role <= 2 && (
                  <Link
                    to="/admin/request-accounts"
                    className={`${
                      pathname === "/admin/request-accounts" ? "active" : ""
                    }`}
                    onClick={() => onShowSidebar(false)}
                  >
                    <span className="material-icons-sharp">
                      format_list_bulleted
                    </span>
                    <h4>Request</h4>
                  </Link>
                )}
                {+currentUser.role >= 3 && (
                  <Link
                    to="/admin/manage-requests"
                    className={`${
                      pathname === "/admin/manage-requests" ? "active" : ""
                    }`}
                    onClick={() => onShowSidebar(false)}
                  >
                    <span className="material-icons-sharp">checklist_rtl</span>
                    <h4>Manage</h4>
                    <span className="badge">
                      {requestAlert.length > 0 && requestAlert.length}
                    </span>
                  </Link>
                )}
              </div>
              <div className="sidebar-menu">
                <h3 className="text-muted">Page</h3>
                <Link
                  to="/admin/manage-pages"
                  className={`${
                    pathname === "/admin/manage-pages" ? "active" : ""
                  }`}
                  onClick={() => onShowSidebar(false)}
                >
                  <span className="material-icons-sharp">layers</span>
                  <h4>Manage</h4>
                </Link>

                {(+currentUser.role === 10 || +currentUser.role === 3) && (
                  <>
                    <Link
                      to="/admin/manage-pages-stock"
                      className={`${
                        pathname === "/admin/manage-pages-stock" ? "active" : ""
                      }`}
                      onClick={() => onShowSidebar(false)}
                    >
                      <span className="material-icons-sharp">inventory</span>
                      <h4>Stock</h4>
                    </Link>

                    <Link
                      to="/admin/upload-pages"
                      className={`${
                        pathname === "/admin/upload-pages" ? "active" : ""
                      }`}
                      onClick={() => onShowSidebar(false)}
                    >
                      <span className="material-icons-sharp">upload</span>
                      <h4>Upload</h4>
                    </Link>
                  </>
                )}
              </div>

              <div className="sidebar-menu">
                <h3 className="text-muted">Request Pages</h3>
                {+currentUser.role <= 2 && (
                  <Link
                    to="/admin/request-pages"
                    className={`${
                      pathname === "/admin/request-pages" ? "active" : ""
                    }`}
                    onClick={() => onShowSidebar(false)}
                  >
                    <span className="material-icons-sharp">
                      format_list_bulleted
                    </span>
                    <h4>Request</h4>
                  </Link>
                )}
                {+currentUser.role >= 3 && (
                  <Link
                    to="/admin/manage-requests-pages"
                    className={`${
                      pathname === "/admin/manage-requests-pages"
                        ? "active"
                        : ""
                    }`}
                    onClick={() => onShowSidebar(false)}
                  >
                    <span className="material-icons-sharp">checklist_rtl</span>
                    <h4>Manage</h4>
                    <span className="badge">
                      {requestPageAlert.length > 0 && requestPageAlert.length}
                    </span>
                  </Link>
                )}
              </div>

                <>
                  <div className="sidebar-menu">
                    <h3 className="text-muted">Vps</h3>
                    <Link
                      to="/admin/vps-alert"
                      className={`${
                        pathname === "/admin/vps-alert" ? "active" : ""
                      }`}
                      onClick={() => onShowSidebar(false)}
                    >
                      <span className="material-icons-sharp">
                        notifications_active
                      </span>
                      <h4>Alert</h4>
                      <span className="badge">
                        {alertCount > 0 && alertCount}
                      </span>
                    </Link>
                  </div>

                  <div className="sidebar-menu">
                    <h3 className="text-muted">Member</h3>
                    <Link
                      to="/admin/members"
                      className={`${
                        pathname === "/admin/members" ? "active" : ""
                      }`}
                      onClick={() => onShowSidebar(false)}
                    >
                      <span className="material-icons-sharp">group</span>
                      <h4>Manage</h4>
                      <span className="badge">
                        {memberCount > 0 && memberCount}
                      </span>
                    </Link>
                  </div>
                </>
         

              {currentUser.role === "10" && (
                <div className="sidebar-menu">
                  <h3 className="text-muted">Users</h3>
                  <Link
                    to="/admin/manage-users"
                    className={`${
                      pathname === "/admin/manage-users" ? "active" : ""
                    }`}
                    onClick={() => onShowSidebar(false)}
                  >
                    <span className="material-icons-sharp">
                      manage_accounts
                    </span>
                    <h4>Manage</h4>
                  </Link>
                </div>
              )}

              <div className="sidebar-menu">
                <a
                  href="https://doc.fbgtshop.com/"
                  target="blank"
                  className="link"
                >
                  <span className="material-icons-sharp">description</span>
                  <h4>Docs</h4>
                </a>

                <Link to="#" className="logout" onClick={logout}>
                  <span className="material-icons-sharp"> logout </span>
                  <h4>Logout</h4>
                </Link>
              </div>
            </>
          </div>
        </aside>
      </SidebarContainer>
    </>
  );
};

export default Sidebar;
